import { useState } from 'react'
import './style.less'
import rest from '../../rest'
import {
  StorePrioritarioType,
  setStore,
  checkError,
  get,
  save,
  saveSend,
  del,
  concluir,
  solicitarRelato,
} from './types'

const StorePrioritario = () => {
  const initialStore: StorePrioritarioType = {
    titulo: '',
    descricao: '',
    departamento: null,
    periodicidade: 0,
    areas_relatoras: [],
    alias_situacao: undefined
  }
  const [store, _setStore] = useState<StorePrioritarioType>(initialStore)
  const [error, setError] = useState<{ [index: string]: any }>({})
  const [success, setSuccess] = useState('')
  const [loading, setLoading] = useState('')

  const checkLoading = (action: string) => loading === action

  const setStore: setStore = obj => {
    _setStore(Object.assign({}, store, obj))
  }

  const checkError: checkError = field => {
    if (error && error[field]) {
      const fieldError = error[field]
      if (Array.isArray(fieldError)) {
        return fieldError[0]
      } else {
        return fieldError
      }
    } else {
      return null
    }
  }

  const clearError = () => {
    setError({})
    setSuccess('')
  }

  const checkSucess = () => success

  const get: get = async id => {
    try {
      clearError()
      setLoading('get')
      const json = await rest(`tema-prioritario/${id}/`)
      _setStore(json)
      setLoading('')
      return json
    } catch (err) {
      setError(err)
      _setStore({ id: id })
      setLoading('')
      throw err
    }
  }

  const save: save = async () => {
    try {
      clearError()
      setLoading('save')
      const json = store.id
        ? await rest(`tema-prioritario/${store.id}/`, 'PUT', store)
        : await rest('tema-prioritario/', 'POST', store)
      _setStore(json)
      setSuccess('Salvo com sucesso')
    } catch (err) {
      setError(err)
    }
    setLoading('')
  }

  const create = async () => {
    const json = await rest('tema-prioritario/', 'POST', store)
    _setStore(json)
    return json
  }

  const saveSend: saveSend = async () => {
    try {
      clearError()
      setLoading('saveSend')
      const card = store.id ? store : await create()
      const json = await rest(`tema-prioritario/${card.id}/enviar/`, 'POST', card)
      _setStore(json)
      setSuccess('Salvo e enviado com sucesso')
    } catch (err) {
      setError(err)
    }
    setLoading('')
  }

  const del: del = async () => {
    try {
      clearError()
      setLoading('del')
      await rest(`tema-prioritario/${store.id}/`, 'DELETE')
      setSuccess('Excluído com sucesso')
      return true
    } catch (err) {
      setError(err)
      setLoading('')
      return false
    }
  }

  const concluir: concluir = async () => {
    try {
      clearError()
      setLoading('concluir')
      const json = await rest(`tema-prioritario/${store.id}/concluir/`, 'POST', store)
      _setStore(json)
      setSuccess('Concluído com sucesso')
    } catch (err) {
      setError(err)
    }
    setLoading('')
  }

  const solicitarRelato: solicitarRelato = async () => {
    try {
      clearError()
      setLoading('solicitar-relato')
      const json = await rest(`tema-prioritario/${store.id}/notificar-areas-com-reportes-atrasados/`, 'POST', store)
      setSuccess('Solicitado com sucesso')
    } catch (err) {
      setError(err)
    }
    setLoading('')
  }

  const api = {
    setStore,
    checkError,
    checkSucess,
    get,
    save,
    saveSend,
    del,
    concluir,
    solicitarRelato,
    checkLoading
  }

  return {
    store,
    api
  }
}

export default StorePrioritario
